export const CONNECTED_APPS_TABS = ['setup', 'connections'] as const;

export type ConnectedAppsTab = (typeof CONNECTED_APPS_TABS)[number];

export const isConnectedAppsTab = (value: string): value is ConnectedAppsTab =>
	CONNECTED_APPS_TABS.some((tab) => tab === value);
